export default "__VITE_ASSET__3682e03d__"